import axios from 'axios';

export default {
  proceedToShop: async function (data) {
    const response = await axios.post('/api/shop', data, { timeout: 30000 });
    return response.data;
  },
};
